import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onMounted } from 'vue';
import { useGlobalStore } from '@/stores';
import { useRoute } from 'vue-router';
import { $t } from '@/i18n';

// components
import PageTitle from '@/components/PageTitle.vue';
import ProjectsList from '@/components/ProjectsList.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectsPage',
  setup(__props) {

const $route = useRoute();
const globalStore = useGlobalStore();
const pageTitleRef = ref();

onMounted(() => {
  globalStore.createVisit($route.path, $t('PROJECTS_LIST'));
  pageTitleRef.value.pageTitle = $t('PROJECTS_LIST');
});

return (_ctx: any,_cache: any) => {
  const _component_WebsiteLayout = _resolveComponent("WebsiteLayout")!

  return (_openBlock(), _createBlock(_component_WebsiteLayout, null, {
    content: _withCtx(() => [
      _createVNode(PageTitle, {
        ref_key: "pageTitleRef",
        ref: pageTitleRef,
        "page-title": _unref($t)('PROJECTS_LIST')
      }, null, 8, ["page-title"]),
      _createVNode(ProjectsList)
    ]),
    _: 1
  }))
}
}

})